import {useCallback, useRef, useState} from "react";

type Params = {
    autoPlay?: boolean;
    muted?: boolean;
};

export const useVideo = (
    {
        autoPlay,
        muted,
    }: Params
) => {
    const videoRef = useRef<HTMLVideoElement>(null);

    const [isMuted, setMuted] = useState(!!muted);
    const [isPlaying, setPlaying] = useState(!!autoPlay);

    const handlePlay = useCallback(() => {
        setPlaying(true);
    }, []);

    const stopPlaying = useCallback(() => {
        setPlaying(false);
    }, []);

    const handleVolumeChange = useCallback(() => {
        if (!videoRef.current) return;

        setMuted(videoRef.current.muted);
    }, []);

    const toggleMute = useCallback(() => {
        const video = videoRef.current;
        if (!video) return;

        video.muted = !video.muted;
    }, []);

    const togglePlay = useCallback(async () => {
        const video = videoRef.current;

        if (!video) return;

        if (video.paused) {
            try {
                await video.play();
            } catch {}
        } else {
            video.pause();
        }
    }, []);

    return {videoRef, isMuted, isPlaying, toggleMute, togglePlay, handlePlay, stopPlaying, handleVolumeChange};
}
